import { validatorPresentDays, validatorPayDay } from './rules'
import selectOptionDict from '@/store/dict/selectOptionDict'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function () {
  // 租赁方案选择
  const leaseSchemeList = [
    {
      el: 'select',
      itemConfig: {
        label: '选择租赁方案',
        prop: 'planId',
        value: 0,
      },
      elConfig: {
        options: {
          label: 'name',
          value: 'id',
          list: [],
        },
        events: {
          change: this.planChange,
        },
      },
    },
  ]
  const leaseSchemeModel = {}
  const leaseSchemeRules = {
    planId: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
  }
  // 车型选择
  const vehicleModelList = [
    {
      itemConfig: {
        prop: 'brandSeriesModel',
      },
      elConfig: {
        showModel: true,
        filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
      },
      render: 'CarBrandSeriesModel',
    },
  ]
  const vehicleModelModel = {
    brandId: '',
    seriesId: '',
    modelId: '',
  }
  const vehicleModelRules = {
    brandId: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
    modelId: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
  }
  //
  // 阶梯配置 默认两个阶梯
  const ladderSchemeConfig = {
    isOpen: 0,
    unit: 1,
    clickNumber: 0, // 点击匹配租金次数
    ladderSchemeList: [
      {
        startMonth: 1, // 开始时间为1
        endMonth: '',
        amount: '',
      },
      {
        startMonth: '',
        endMonth: '',
        amount: '',
      },
    ],
  }

  // 租赁设置顶部预览
  const leaseSetupTopPreviewList = [
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'rentCalculationRules',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
        width: 110,
      },
    },
  ]

  // 支付计划校验
  const m_rules = {
    presentDays: [
      { validator: validatorPresentDays.bind(this), trigger: 'change' },
    ],
    payDay: [
      { validator: validatorPayDay, trigger: 'change' },
    ],
  }

  // 支付计划底部统计默认展示列表
  const m_bottomTotalDefaultList = [
    {
      code: 1,
      number: 0,
    },
    {
      code: 2,
      number: 0,
    },
    {
      code: 3,
      number: 0,
    },
    {
      code: 4,
      number: 0,
    },
  ]
  // 周付 缴款日下拉列表
  const weekList = [
    {
      code: 1,
      name: '每周一',
    },
    {
      code: 2,
      name: '每周二',
    },
    {
      code: 3,
      name: '每周三',
    },
    {
      code: 4,
      name: '每周四',
    },
    {
      code: 5,
      name: '每周五',
    },
    {
      code: 6,
      name: '每周六',
    },
    {
      code: 7,
      name: '每周日',
    },
  ]
  // 日期配置
  const pickerOptions = {
    pickerOptions: {
      shortcuts: [
        {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          },
        },
        {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          },
        },
      ],
    },
  }

  // 车辆选择
  const vehicleSelectionList = [
    {
      el: 'select',
      itemConfig: {
        label: '是否备车',
        prop: 'readyLeaseState',
      },
      elConfig: {
        options: {
          label: 'label',
          value: 'value',
          list: this.dictParseList(selectOptionDict.isWhetherList),
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '绑定车辆',
        prop: 'plateNo',
      },
      elConfig: {
        options: {
          label: 'plateNo',
          value: 'id',
          list: [],
        },
        events: {
          change: this.plateNoChange,
        },
      },
    },
  ]
  const vehicleSelectionModel = {}
  const vehicleSelectionRules = {
    plateNo: [
      { required: true, message: '请选择', trigger: 'change' },
    ],
  }
  // 车辆信息
  const vehicleInfoList = [
    {
      el: 'text',
      itemConfig: {
        label: '车辆ID',
        prop: 'carId',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车辆状态',
        prop: 'vehicleStatus',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '车辆库存状态',
        prop: 'inventoryStateName',
      },
    },
  ]
  const vehicleInfoModel = {}

  return {
    leaseSetupList: {
      leaseSchemeList,
      vehicleModelList,
      vehicleInfoList,
      vehicleSelectionList,
      weekList,
      leaseSetupTopPreviewList,
    },
    leaseSetupModel: {
      leaseSchemeModel,
      vehicleModelModel,
      vehicleInfoModel,
      vehicleSelectionModel,
    },
    leaseSetupRules: {
      leaseSchemeRules,
      vehicleModelRules,
      vehicleSelectionRules,
    },
    m_rules,
    ladderSchemeConfig,
    pickerOptions,
    weekList,
    m_bottomTotalDefaultList,
  }
}
